module.exports = __webpack_public_path__ + "998703ded0fefdc7df872589870ac4bf.png";